import React, { Component, ErrorInfo, FunctionComponent } from 'react';

import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('error');

import { ErrorDetails } from './ErrorDetails';

export interface CaughtError {
  error: Error;
  info: ErrorInfo;
}

export const DefaultErrorHandler: FunctionComponent<{
  caughtError: CaughtError;
}> = ({ caughtError }) => (
  <div style={{ padding: 20 }}>
    <h3>
      <span style={{ color: '#DE350B', marginRight: 10 }}>
        {format('global-unhandled')}
      </span>
    </h3>
    <ErrorDetails caughtError={caughtError} />
  </div>
);

export class ErrorBoundary extends Component<
  { errorHandlerComponent?: FunctionComponent<{ caughtError: CaughtError }> },
  { caughtError: CaughtError | null }
> {
  state = {
    caughtError: null,
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    // In development mode, React doesn't actually catch the error, but in
    // production we need to propagate the error so that the global error
    // handler can pick it up. This must be done asynchronously so React doesn't
    // catch it again.
    if (!__DEV__) {
      setTimeout(() => {
        throw error;
      }, 0);
    }

    this.setState({
      caughtError: { error, info },
    });
  }

  render() {
    const { caughtError } = this.state;

    if (caughtError) {
      const ErrorHandlerComponent =
        this.props.errorHandlerComponent || DefaultErrorHandler;

      return <ErrorHandlerComponent caughtError={caughtError} />;
    }

    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./app/common/components/ErrorBoundary/ErrorBoundary.tsx